/* eslint-disable quotes */
import type { TypeLang, TypeJsonLdContactPageData } from '@/schema'
import { buildUrl, buildBreadcrumb, getIetfLang, BREADCRUMB_HOME } from './_url'
import { buildOrganization } from './_organization'

export function jsonLdContactPage(data: TypeJsonLdContactPageData, locale: TypeLang) {
  const url = buildUrl(locale, '/contact')

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ContactPage",
        "@id": `${url}/#webpage`,
        "url": url,
        "name": data.name,
        "description": data.description,
        "inLanguage": getIetfLang(locale),
        "isPartOf": {
          "@id": `${buildUrl(locale)}/#website`
        },
        "breadcrumb": {
          "@id": `${url}/#breadcrumb`
        }
      },
      {
        ...buildBreadcrumb(locale, [
          { name: BREADCRUMB_HOME[locale], path: '' },
          { name: data.name, path: '/contact' }
        ]),
        "@id": `${url}/#breadcrumb`
      },
      {
        ...buildOrganization(locale, 'full'),
        "@id": `${buildUrl(locale)}/#organization`
      }
    ]
  }

  return JSON.stringify(schema)
}
